import links from 'links'
import cx from 'classnames'
import { useDevice } from 'device'
import React, { useMemo } from 'react'
import { useModuleTitle } from 'models/settings'

import { Grid } from 'components/layout'
import { Href } from 'components/navigation'
import { Image, Text, TextColor } from 'components/dataDisplay'

import s from './ProjectsBlock.scss'

import polkImage from './images/polk.png'
import projectsImage from './images/projects.png'


const ProjectsBlock = (props) => {
  const { className, isWithHeroes, isWithPlans } = props

  const { title: immortalsModuleTitle } = useModuleTitle('IMMORTALS')
  const { title: plansModuleTitle } = useModuleTitle('CITY_PROJECTS')
  const { isMobile, isDesktop } = useDevice()

  const projectsList = useMemo(() => {
    return [
      isWithHeroes && {
        className: 'bg-jaws-warrior',
        color: 'schindler' as TextColor,
        title: immortalsModuleTitle,
        text: `
          Опубликуйте фотографии и рассказы ваших близких
          о войне, сохранив их имена для истории России
        `,
        to: links.immortals.root,
        image: polkImage,
      },
      isWithPlans && {
        className: 'bg-amadeus–shawshank',
        color: 'oldboy' as TextColor,
        title: plansModuleTitle,
        text: `
          Будьте в курсе проектов и инициатив администрации
          по благоустройству и модернизации города
        `,
        to: links.projects.root,
        image: projectsImage,
      },
    ].filter(Boolean)
  }, [ immortalsModuleTitle, isWithHeroes, isWithPlans, plansModuleTitle ])

  return (
    <div className={className}>
      <Text
        message="Планы и проекты города"
        size={isMobile ? 'h20-28' : 'h32'}
        color="titanic"
      />
      <Grid
        className="pt-32px"
        columns={isDesktop ? 2 : 1}
        gutter={32}
      >
        {
          projectsList.map(({ className, color, title, text, to, image }, index) => (
            <Href
              key={index}
              className={cx(className, s.container, 'radius-24', {
                'flex': !isMobile,
                'block': isMobile,
              })}
              to={to}
            >
              {
                isMobile && (
                  <div className={cx(s.imageContainer, 'relative flex-none overflow-hidden')}>
                    <Image
                      className="absolute h-full top-0 left-0"
                      src={image}
                      // width="156"
                      height="120"
                    />
                  </div>
                )
              }
              <div className={cx('flex-1', isMobile ? 'mt-12px px-16px pb-16px' : 'py-32px pl-24px')}>
                <Text
                  message={title}
                  size="h24"
                  color={color}
                />
                <Text
                  className="mt-12px opacity-72 overflow-ellipsis-3"
                  message={text}
                  size="t16-24"
                  color={color}
                />
              </div>
              {
                !isMobile && (
                  <div className={cx(s.imageContainer, 'relative flex-none overflow-hidden ml-24px')}>
                    <Image
                      className="absolute h-full top-0 left-0"
                      src={image}
                      // width={isDesktop ? '179' : '221'}
                      height="184"
                    />
                  </div>
                )
              }
            </Href>
          ))
        }
      </Grid>
    </div>
  )
}

export default ProjectsBlock